import { render, staticRenderFns } from "./SupportLayout.vue?vue&type=template&id=26171a96&scoped=true"
import script from "./SupportLayout.vue?vue&type=script&lang=js"
export * from "./SupportLayout.vue?vue&type=script&lang=js"
import style0 from "./SupportLayout.vue?vue&type=style&index=0&id=26171a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.106.2_postcss@8.5.15___lodash@4.18.1_pre_97827144a0f6aa48df0612a675550f8c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26171a96",
  null
  
)

export default component.exports